import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=45281837&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=45281837&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45281837",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45281837')) {
      api.createRecord('45281837', component.options)
    } else {
      api.reload('45281837', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=45281837&scoped=true", function () {
      api.rerender('45281837', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recruitment/edit.vue"
export default component.exports